import React from 'react'

export default function AboutHead() {
  return (
    <>
      <section className="about-head-area about-head-first">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 col-md-7 order-1 order-md-0">
              <div className="about-head-content">
                <span>About us</span>
                <h1 className="heading">Making Documents Simple, Smart, Secure</h1>
                <p>At Dox and Box, we are redefining how organizations manage, store, and access information in a rapidly evolving digital world, making it easier and more efficient than ever.  Our mission is to simplify complete document-driven processes through secure, intelligent, scalable solutions that help businesses operate with greater efficiency and control. With us, businesses can focus on growth while we take care of the information that powers their operations.</p>
              </div>
            </div>
            <div className="col-lg-5 col-md-5 order-0 order-md-1">
              <div className="about-head-img">
                <img src="/assets/images/about-head-1.webp" alt="About Head" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ----------------------------------------- */}

      <section className="about-head-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 col-md-5">
              <div className="about-head-img">
                <img src="/assets/images/about-head-2.webp" alt="About Head" />
              </div>
            </div>

            <div className="col-lg-7 col-md-7">
              <div className="about-head-content">
                <span>Our Story</span>
                <h2 className="heading">Two Decades of Simplifying <span>Workflows</span></h2>
                <p>For over 20 years, we have been transforming how work gets done by removing inefficiencies from document-heavy processes. Our focus has always been to streamline operations, reduce manual effort, build systems that make business workflows faster, smarter, more reliable.</p>
                <p>Over time, we have partnered with organizations across industries to eliminate paperwork challenges and modernize their document ecosystems. From physical records management to digital transformation, our solutions help teams shift their focus from administrative burden to strategic growth.</p>
                <p>Today, we continue to evolve with the changing needs of enterprises, delivering scalable and future-ready solutions that enhance productivity, visibility, operational excellence.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --------------------------------------- */}

      <section className="about-head-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 col-md-7 order-1 order-md-0">
              <div className="about-head-content">
                <span>high-trust by design</span>
                <h2 className="heading">Reliable Security, Privacy, Compliance </h2>
                <p>At Dox and Box, protecting your information is not just a responsibility—it is the foundation of everything we do. In a world where data security is critical, we ensure that every document we manage is handled with strict confidentiality, accuracy, care.</p>
                <p>We follow robust security protocols and industry best practices to safeguard physical and digital records at every stage of their lifecycle. From secure storage and controlled access to compliant destruction and encrypted digital systems, our processes are designed to meet the highest standards of trust and reliability.</p>
                <p>Our commitment is continuous improvement. We constantly strengthen our systems, technologies, operational frameworks to ensure your data remains protected, compliant, fully secure—always.</p>
              </div>
            </div>
            <div className="col-lg-5 col-md-5 order-0 order-md-1">
              <div className="about-head-img">
                <img src="/assets/images/about-head-3.webp" alt="About Head" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
